<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="ads-put-in-key">
    <el-table
      :data="tableData"
      border
      size="mini"
      style="width: 100%"
      cell-class-name="table-cell-no-padding"
      row-class-name="table-row-no-padding"
      header-cell-class-name="table-header-cell"
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="item in theadList"
        :key="item.id"
        :type="item.propName == 'index' ? 'index' : ''"
        :prop="item.propName"
        :label="item.labelName"
        :formatter="(row, column, value) => dataFormAtter(value, item, column)"
        :sortable="item.sortable"
        :sort-method="item.sortMethod"
        :width="item.width"
        :align="item.textAlign"
      >
        <template slot="header" slot-scope="scope">
          <div v-if="!shopSlotStatus(item, 'showHeadSwitch')">{{ item.labelName }}
          </div>
          <el-switch
            v-model="item.overallStatus"
            :active-value="item.headActiveValue"
            :inactive-value="item.headInActiveValue"
            v-if="headShopSlotStatus(item, 'showHeadSwitch')"
            @change="
              (val) => {
                headSwitchChange(val, scope);
              }
            "
          ></el-switch>
          <div v-if="headShopSlotStatus(item, 'showHeadTextButton')">
            <el-button type="text" @click.stop="(val) => {
                headTextButtonClick(val, scope);
              }" v-text="item.headTextButtonName" :size="item.headTextButtonSize"></el-button>
          </div>
        </template>
        <template v-slot:default="scope" v-if="shopSlotStatus(item)">
          <el-switch
            v-model="scope.row[item.propName]"
            :active-value="item.activeValue"
            :inactive-value="item.inactiveValue"
            v-if="shopSlotStatus(item, 'showSwitch')"
            @change="
              (val) => {
                switchChange(item.propName,val, scope);
              }
            "
          ></el-switch>
          <el-input
            v-model="scope.row[item.propName]"
            size="small"
            v-if="shopSlotStatus(item, 'showInput')"
            @change="
              (val) => {
                inputChange(val, scope, item.propName);
              }
            "
            @focus="
              (event) => {
                inputFocus(event, scope, item.propName);
              }
            "
          ></el-input>
          <el-image
            style="height: 40px; width: 40px"
            :src="imageSrc(scope.row, item.propName)"
            fit="fill"
            @click="() => imageClick(scope.row)"
            v-if="shopSlotStatus(item, 'showImage')"
          >
          </el-image>
          <a
            v-if="shopSlotStatus(item, 'showLink')"
            :href="scope.row.productUrl"
            target="_blank"
            style="text-decoration: none; color: rgb(88, 147, 255)"
          >{{ scope.row[item.propName] }}</a>
          <el-button type="text" v-if="shopSlotStatus(item, 'showErrorLink') && scope.row.errorLogSize > 0"
             style="color: #f56c6c;font-size: 12px;" @click="errorBtnClick(scope.row.campaignId,scope.row.id,item.businessType)"
          >异常原因</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="错误日志" :visible.sync="dialogFormVisible" width="80%">
      <ads-error-list :queryData="queryData" ref="errorListPage">
      </ads-error-list>
    </el-dialog>
  </div>
</template>

<script>

  import adsErrorList from '@v/adsMgmt/children/adsErrorList'

  export default {
    props: {
      tableData: {
        type: Array,
        default() {
          return [];
        },
      },
      theadList: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        dialogFormVisible : false,
        queryData: {},
      };
    },
    activated(){
    },
    components: {
      adsErrorList
    },
    methods: {
      sortChange({ column, prop, order }){
        this.tableData.sort((a, b) => {
          if(!a.hasOwnProperty('status')){
            return 0;
          }
          if (a.status==2) {
            return order=="descending"? -1:1
          } else if(a.status == 1){
            return order=="descending"? 1:-1
          } else {
            return 0
          }
        })
      },
      dataFormAtter(value, item, column) {
        if ([null, undefined, ''].includes(value)) {
          return "--";
        }
        if (item.propName === 'clickRate') {
          if (isNaN(+value)) {
            return value
          }
          return this.$utils.floatRide(+value, 100).toFixed(2) + '%';
        }
        return value;
      },
      shopSlotStatus(row, propName) {
        if (propName) {
          return !!row[propName];
        }
        return !!(row.showInput || row.showSwitch || row.showImage || row.showLink || row.showErrorLink);
      },
      headShopSlotStatus(row, propName) {
        if (propName) {
          return !!row[propName];
        }
        return row.showHeadSwitch;
      },
      switchChange(porpName,newVal, scope) {
        this.$emit("switch-change", porpName, newVal, scope);
      },
      headSwitchChange(newVal) {
        this.$emit("head-switch-change", newVal);
      },
      headTextButtonClick(newVal) {
        this.$emit("head-text-button-click",newVal);
      },
      inputFocus(event, scope, propName) {
        this.oldInputValue = scope.row[propName];
      },
      inputChange(newVal, scope, propName) {
        this.$confirm("是否确认修改?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$emit(
              "input-change",
              newVal,
              scope,
              propName,
              this.oldInputValue
            );
          })
          .catch((err) => {
            console.log(err);
            scope.row[propName] = this.oldInputValue;
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      imageClick(row) {
        // window.open(row.productUrl);
        // console.log(row);
        this.$emit("image-click", row);
      },
      linkClick(row) {
        this.$emit("image-click", row);
      },
      imageSrc(row, propName) {
        return row[propName].replace('https://logcapital.cn', '');
      },
      errorBtnClick(campaignId,businessId,businessType){
        this.queryData.campaignId = campaignId;
        this.queryData.businessId = businessId;
        this.queryData.businessType = businessType;
        if(this.$refs && this.$refs.errorListPage) {
          this.$refs.errorListPage.queryErrorList();
        }
        this.dialogFormVisible = true;
      },
    }
  };
</script>

<style lang="scss">

</style>
